import {AuthorizationNodeModel} from "./authorization.node.model";

export class FlatIdfAuthoritiesModel {
  flat_idf_authorities: AuthorizationNodeModel;

  constructor(obj: any = {}) {
    this.flat_idf_authorities = obj && obj.flat_idf_authorities || null;
  }
}
